import { matchPath, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { withLeadingSlash } from 'utils/stringUtils';
import { getLibraryList } from 'utils/libraryUtils';
import { getUrlCountryPath } from 'utils/urlUtils'
import { routesQuery } from './routesQuery';
import { webinarQuery } from './webinarRoutes';
import { getAPIContent } from 'api/acousticApi/index';

// cache key for the routes query
const ROUTES_QUERY_KEY = 'routes-query';
const WEBINAR_QUERY_KEY = 'webinars-query';

// method to parse the data returned from the acoustic api search query
// and turn it into a useful array of routes
// routes returned have the form { contentId, templateType, path }
const parseRouteData = (data) => {
  if (!data) { return null; }
  const documents = data && data.data ? data.data.documents : null;
  if (!documents) { return null; }
  let routes = documents.map((document) => {
    const {
      id,
      type,
      string1,
      string4
    } = document;
    const slugValue = string1 && string1.length ? string1[0] : null;
    const locale = string4 && string4.length ? string4[0] : "";
    if (!slugValue) {
      // if the content does not have a defined urlSlug, it shouldn't be included in the routes
      return null;
    }
    const path = withLeadingSlash(slugValue);
        return ({
      contentId: id,
      templateType: type,
      path,
      locale:locale
    });
  });
  // remove any null routes before returning
  // remove duplicates here

  routes = routes.filter(Boolean);

  let oneLocalePages = routes.filter(item=>item.locale === '');
  let multipleLocalePages = routes.filter(item=>item.locale != '');

  if(multipleLocalePages)
  {
    const culture = getUrlCountryPath();   
    multipleLocalePages = routes.filter(item=>item.locale === culture);

    oneLocalePages = oneLocalePages.filter(
    base => !multipleLocalePages.some(local => local.path === base.path)
    );

    oneLocalePages=oneLocalePages.concat(multipleLocalePages);

  }  
  return oneLocalePages;//routes.filter(Boolean);
};

const useApiRoutes = () => {
  // useQuery takes a key for a query, and a callback that runs the query
  // and then caches the results. It also deals with loading fetching etc.
  // https://react-query.tanstack.com/docs/overview
  const { isLoading, error, data } = useQuery(
    ROUTES_QUERY_KEY,
    routesQuery,
    { staleTime: Infinity }, // only request the api routes once
  );
  const preferred = "en-gb"; //get based on url
  //const unique = data ? uniqueRoutes(data, preferred) : null; ;

  //console.log(unique);

  const routes = data ? parseRouteData(data) : null;

  return { routes, isLoading, error };
};

const useWebinarsQuery = () => {
  // useQuery takes a key for a query, and a callback that runs the query
  // and then caches the results. It also deals with loading fetching etc.
  // https://react-query.tanstack.com/docs/overview
  const { isLoading, error, data } = useQuery(
    WEBINAR_QUERY_KEY,
    webinarQuery,
    { staleTime: Infinity }, // only request the api routes once
  );
  const webinars = data ? data : null;
  return { webinars, isLoading, error };
};



const useCurrentApiRoute = () => {
  const { routes } = useApiRoutes();
  const location = useLocation();
  const currentPath = location.pathname;
  return routes && routes.find((route) => {
    const match = matchPath(currentPath, {
      path: route.path,
      exact: true,
    });
    return match;
  });
};

export {
  useApiRoutes,
  useCurrentApiRoute,
  useWebinarsQuery,
};
